import * as React from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface ToastProps {
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'warning' | 'info';
    onClose: () => void;
}

export default function Toast({ open, message, severity, onClose }: ToastProps) {
    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose();
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={1500}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            style={{ marginTop: '70px' }}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{
                    width: '100%',
                    '&.MuiAlert-standardSuccess, &.MuiAlert-filledSuccess': {
                        backgroundColor: 'accent.main',
                        color: '#FFFFFF'
                    },
                    '&.MuiAlert-standardError, &.MuiAlert-filledError': {
                        backgroundColor: 'error.main',
                        color: 'error.contrastText'
                    },
                    '&.MuiAlert-standardWarning, &.MuiAlert-filledWarning': {
                        backgroundColor: 'warning.main',
                        color: 'warning.contrastText'
                    },
                    '&.MuiAlert-standardInfo, &.MuiAlert-filledInfo': {
                        backgroundColor: 'primary.main',
                        color: 'primary.contrastText'
                    }
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}